import moment from "moment";
import firestore from "../../../firebase/firestore";
import { getBilling } from "../../../services/billing";

export default {
  resetFilter({ commit }) {
    commit("resetState");
  },
  DialogDetails({ commit }, param) {
    commit("setDialogDetails", param);
  },
  async getTotalBillings({ commit }, params) {
    try {
      if (params) {
        commit("setFilters", params);
        commit("setLoadingTotalBillings", true);
        commit("setTotalBillings", []);
        commit("setItems", []);
        commit("setLastItem", null);
        commit("setItemsComplete", []);
        commit("setTotalItems", 0);

        let userRef = firestore.collection("TotalBilling");
        let powerPlantRef = firestore.collection("power_plants");
        // let number_of_months = params.number_of_months || 6
        let competence = params.competence;
        let competence_month = competence.substring(0, 2);
        let competence_year = competence.substring(2, 6);
        let formatcompetence = competence_year + "-" + competence_month;
        // console.log('power_plant: ', params.power_plant)
        let power_plant_id = params.power_plant.id;

        //Trata os meses que devem ser baixados
        let competences =
          (await getCompetences(competence_year, competence_month)) || [];

        userRef = userRef
          .where("competence", "in", competences)
          .where("power_plant_id", "==", power_plant_id);

        return userRef.onSnapshot(
          { includeMetadataChanges: true },
          async (res) => {
            let powerPlant = (
              await powerPlantRef.doc(power_plant_id).get()
            ).data();
            let TotalBillings = [];
            const changes = res.docChanges();
            // eslint-disable-next-line no-unused-vars
            for (const [idx, change] of changes.entries()) {
              const { newIndex, oldIndex, doc, type } = change;

              if (change.type === "added") {
                // eslint-disable-next-line no-unused-vars
                let new_doc = {
                  id: doc.id,
                  ...doc.data(),
                  power_plant: params.power_plant,
                  installation_number: powerPlant.installation_number || "",
                };

                TotalBillings.splice(newIndex, 0, new_doc);
                if (new_doc.competence === formatcompetence) {
                  commit("setTotalBilling", new_doc);
                  // console.log('sumarize: ', doc.data().summarize)
                  if (doc.data() && doc.data().summarize)
                    commit(
                      "setTotalItems",
                      doc.data().summarize.totalItems || 0,
                    );
                }
              } else if (change.type === "modified") {
                // remove the old one first
                TotalBillings.splice(oldIndex, 1);
                // if we want to handle references we would have to unsubscribe
                // from old references' listeners and subscribe to the new ones
                let new_doc = {
                  id: doc.id,
                  ...doc.data(),
                  power_plant: params.power_plant,
                  installation_number: powerPlant.installation_number || "",
                };
                if (new_doc.competence === formatcompetence) {
                  commit("setTotalBilling", new_doc);
                  if (doc.data() && doc.data().summarize)
                    commit(
                      "setTotalItems",
                      doc.data().summarize.totalItems || 0,
                    );
                }

                TotalBillings.splice(newIndex, 0, new_doc);
              } else if (type === "removed") {
                // if(sale.data().payment_competence) salesPaid = salesPaid + 1
                TotalBillings.splice(oldIndex, 1);
                // if we want to handle references we need to unsubscribe
                // from old references
              }
            }
            // console.log('setTotalBillings: ', TotalBillings)
            commit("setTotalBillings", TotalBillings);
            commit("setLoadingTotalBillings", false);
            return TotalBillings;
          },
        );
      }
    } catch (err) {
      commit("setTotalBillings", []);
      commit("setLoadingTotalBillings", false);
      console.error(err);
    }
  },
  async getUniqueBillingByParams({ commit }, params) {
    try {
      if (params) {
        // commit('setBillingFilters', params)
        commit("setBillingItems", []);
        commit("setLoading", true);
        let billingRef = firestore.collection("billing");
        if (params.power_plant_id)
          billingRef = billingRef.where(
            "power_plant_id",
            "==",
            params.power_plant_id,
          );
        if (params.competence) {
          let year = params.competence.substring(2, 6);
          let month = params.competence.substring(0, 2);
          console.log("comp: ", year + "-" + month);

          billingRef = billingRef.where("competence", "==", year + "-" + month);
        }
        if (params.status && params.status.length > 0) {
          // console.log('params.status: ', params.status)
          billingRef = billingRef.where("status", "in", params.status);
        }
        billingRef = billingRef.where("unique_billing", "==", true);
        let billings = await billingRef.get();
        console.log("billings: ", billings.size);
        if (billings.size > 0) {
          // for(let i=0; i > billings.size; i++) {}
          let items = [];
          for (let i = 0; i < billings.size; i++) {
            let doc = billings.docs[i];
            let obj = { id: doc.id, ...doc.data() };
            let uc = await firestore
              .collection("consumer_units")
              .doc(obj.consumer_unit)
              .get();
            if (uc.exists) {
              obj.consumer_unit = {
                id: uc.id,
                ...uc.data(),
              };
              console.log("uc: ", obj.consumer_unit);
            }
            await items.push(obj);
          }
          // let items = await billings.docs.map(async doc => {
          //     let obj = { id: doc.id, ...doc.data() }
          //     let uc = await firestore.collection("consumer_units").doc(obj.consumer_unit).get()
          //     if(uc.exists) {
          //         obj.consumer_unit = {
          //             id: uc.id,
          //             ...uc.data()
          //         }
          //     }
          //     return obj
          // })
          commit("setBillingItems", await items);
          commit("setLoading", false);
        } else {
          commit("setBillingItems", []);
          commit("setLoading", false);
        }
      } else {
        commit("setBillingItems", []);
        commit("setLoading", false);
      }
    } catch (err) {
      commit("setBillingItems", []);
      commit("setLoading", false);
      // commit('setLoadingTotalBillings', false)
      console.error(err);
    }
  },
  async getBillings({ commit, state }, params) {
    try {
      if (params) {
        let lastItem = null;
        // console.log('state.lastItem, ', state.lastItem)
        if (state.lastItem) {
          lastItem = await firestore
            .collection("consumer_units")
            .doc(state.lastItem)
            .get();
        }
        // console.log('lastItem1: ', lastItem)
        commit("setItems", []);
        // commit('setLoadingBillings', true)
        // console.log('setLoadingBillings: ', state.loadingBillings)
        let items_Complete = state.itemsComplete;

        const {
          // sortBy, descending,
          page,
          rowsPerPage,
        } = params.pagination;

        // console.log('params.pagination_before: ', params.pagination_before)
        // console.log('params.pagination.page: ',params.pagination.page)

        if (params.pagination_before) {
          // console.log('params.pagination_before.page: ', params.pagination_before.page)
          // console.log('params.pagination_before.page > params.pagination.page: ',params.pagination_before.page > params.pagination.page)
          // console.log('params.pagination_before.page <= params.pagination.page: ',params.pagination_before.page <= params.pagination.page)
          // console.log('params.pagination.page <= (state.itemsComplete.length/rowsPerPage)): ', params.pagination.page <= (state.itemsComplete.length/rowsPerPage))
          // console.log('params.pagination_before.page === params.pagination.page: ', params.pagination_before.page === params.pagination.page)
        }
        if (
          params.pagination_before &&
          params.pagination_before.page > params.pagination.page
        ) {
          commit("setLoadingBillings", true);
          let items = state.itemsComplete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          commit("setItems", items);
          commit("setLoadingBillings", false);
          // console.log('setLoadingBillings1: ', state.loadingBillings)

          /*
                  Se selecionou proxima página, mas a pagina selecionada já foi carregada antes
                  Pega os dados direto do array itemsComplete
                  */
        } else if (
          params.pagination_before &&
          params.pagination_before.page <= params.pagination.page &&
          params.pagination.page <= state.itemsComplete.length / rowsPerPage
        ) {
          commit("setLoadingBillings", true);
          let items = state.itemsComplete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          commit("setItems", items);
          commit("setLoadingBillings", false);
          // console.log('setLoadingBillings2: ', state.loadingBillings)

          // Se a pagina é a mesma não faz nada
        } else if (
          params.pagination_before &&
          params.pagination_before.page === params.pagination.page
        ) {
          commit("setLoadingBillings", true);
          let items = state.itemsComplete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          commit("setItems", items);
          commit("setLoadingBillings", false);
          // console.log('setLoadingBillings3: ', state.loadingBillings)
          /*
                  Se selecionou proxima página, e a pagina selecionada ainda não foi carregada antes
                  Busca os dados no firebase e adiciona ao array os dados firebase
                  */
        } else {
          commit("setLoadingBillings", true);
          commit("setLastItem", null);

          // console.log('setLoadingBillings4: ', state.loadingBillings)
          // params.pagination_before = params.pagination
          let ref = firestore.collection("consumer_units");
          // let number_of_months = params.number_of_months || 6
          let competence = params.competence;
          let competence_month = competence.substring(0, 2);
          let competence_year = competence.substring(2, 6);
          let formatcompetence = competence_year + "-" + competence_month;
          // console.log('power_plant: ', params.power_plant)
          let power_plant_id = params.power_plant.id;

          ref = ref.where("power_plant_id", "==", power_plant_id);

          if (params.name) {
            ref = ref.where(
              "name_insensitive",
              ">=",
              params.name.toLowerCase(),
            );
          } else if (params.email) {
            ref = ref.where("email", "==", params.email);
          } else if (params.installation_number) {
            ref = ref.where(
              "installation_number",
              "==",
              params.installation_number,
            );
          } else if (params.status) {
            ref = ref.where("status", "==", params.status);
          }

          if (params.competence) {
            ref = ref.where("billing_competence_start", "<=", formatcompetence);
            // .where('billing_competence_end', '<=', competence)
          }

          if (lastItem && lastItem.exists) {
            // console.log('lastItem exists: ', lastItem)
            ref = ref.startAfter(lastItem);
          } else {
            if (params.name) {
              ref = ref.orderBy(
                "name_insensitive",
                params.pagination && params.pagination.descending
                  ? "desc"
                  : "asc",
              );
            } else if (params.competence) {
              // ref = ref.orderBy('billing_competence_start', params.pagination.descending?'desc':'asc')
            } else {
              // ref = ref.orderBy('created_at', this.pagination.descending?'desc':'asc')
              ref = ref.orderBy(
                "name_insensitive",
                params.pagination && params.pagination.descending
                  ? "desc"
                  : "asc",
              );
            }
          }
          // console.log('last: ', state.last)

          if (params.pagination && params.pagination.rowsPerPage) {
            // console.log('rowsPerPage: ', params.pagination.rowsPerPage)
            // if(params.pagination.rowsPerPage === -1) params.pagination.rowsPerPage = 2000
            ref = ref.limit(params.pagination.rowsPerPage || 25);
          }
          // console.log('setLoadingBillings4.1: ', state.loadingBillings)

          /*
                    if(params.limit) {
                        ref = ref.limit(params.limit)
                    } else {
                        ref = ref.limit(100)
                    }
                    */

          return ref.onSnapshot(
            { includeMetadataChanges: true },
            async (res) => {
              // console.log('setLoadingBillings4.2: ', state.loadingBillings)
              // console.log('res.docs.length: ', res.docs.length)
              if (res.docs.length === 0) {
                commit("setTotalItems: ", state.itemsComplete.length);
                commit("setLoadingBillings", false);
                return;
              }
              // if(res.docs.length < params.pagination.rowsPerPage) {
              //     let totalItems = ((params.pagination.page - 1) * params.pagination.rowsPerPage) + res.docs.length
              //     console.log('totalItems: ', totalItems)
              //     // params.pagination.totalItems = totalItems
              //     let pag = {
              //         ...params.pagination,
              //         totalItems
              //     }
              //     commit('setPagination', pag)
              // }
              // console.log('setPagination: ', params.pagination)

              let Billings = [];
              const changes = res.docChanges();
              // console.log(changes)
              // eslint-disable-next-line no-unused-vars
              //let last = this.$state.items.docs[this.$state.items.docs.length - 1];
              //let last = changes[changes.length - 1];
              //console.log('setLastItem: ', last)
              // commit('setLastItem', last)
              // let contador = changes.length - 1
              // for (var i = 0; i < (res.size - 1); i++) {
              for await (const [idx, change] of changes.entries()) {
                const { newIndex, oldIndex, doc, type } = change;
                // if((doc.data().status === 'canceling' || doc.data().status === 'inactivated' || doc.data().status === 'canceled') && doc.data().billing_competence_end <= formatcompetence) {
                //     if(idx >= (changes.length - 1)) {
                //         console.log('doc:', doc.id)
                //         commit('setLastItem', doc.id)
                //         console.log("last3: ", state.lastItem)

                //         commit('setLoadingBillings', false)
                //         // console.log('setLoadingBillings5: ', state.loadingBillings)

                //         // console.log('Fim: ',Billings)
                //         commit('setItems', Billings)
                //         commit('setItemsComplete', state.itemsComplete.concat(Billings))
                //         // commit('setLastItem', Billings[Billings.length - 1])
                //         // commit('setLoadingTotalBillings', false)
                //     }
                //     continue
                // }
                if (type === "added") {
                  // console.log('setLoadingBillings_add4.idx' + idx + ':,' + state.loadingBillings)
                  // eslint-disable-next-line no-unused-vars
                  const billings = await firestore
                    .collection("billing")
                    .where("consumer_unit", "==", doc.id)
                    .where("competence", "==", formatcompetence)
                    .limit(1)
                    .get();

                  // console.log('billings.size > 0: ', billings.size)
                  if (billings.size > 0) {
                    // const billing_changes = billings.docChanges()
                    // console.log('billing_changes: ', billing_changes)
                    const docBill = billings.docs[0];
                    const data = {
                      id: doc.id,
                      ...doc.data(),
                      billing: {
                        id: docBill.id,
                        ...docBill.data(),
                      },
                    };
                    await Billings.splice(newIndex, 0, data);
                    // console.log("Billings1: ")
                    // // items_Complete.push(data)
                    // console.log("items_Complete1: ", data)
                    // for (var x = 0; x < (billings.size - 1); x++) {
                    // // for(const bill of billing_changes.entries()) {
                    //     // const { newBillIndex, oldBillIndex, docBill, typeBill } = bill
                    //     const docBill = billings.docs[x]
                    //     console.log('bill type: ', docBill)
                    //     const data = {
                    //         sum,
                    //         id: doc.id,
                    //         ...doc.data(),
                    //         billing: {
                    //             id: docBill.id,
                    //             ...docBill.data()
                    //         }
                    //     }
                    //     await Billings.splice(newIndex, 0, data)
                    //     sum = sum++
                    //     // await items.push(data)
                    //     // await items_complete.push(data)
                    // }
                  } else {
                    const data = {
                      id: doc.id,
                      ...doc.data(),
                      billing: null,
                    };
                    await Billings.splice(newIndex, 0, data);
                    // console.log("Billings2: ")
                    // console.log("items_Complete2: ", data)
                    // await items.push(data)
                    // await items_complete.push(data)
                  }
                  // console.log('idx: ', idx)
                  // console.log('newIndex: ', changes.length -1)
                  // if(idx === changes.length -1) {
                  //     commit('setLastItem: ', doc.ref.get())
                  // }
                  // .onSnapshot({ includeMetadataChanges: true}, async (billing_res) => {

                  // let new_doc = {
                  //     id: doc.id,
                  //     ...doc.data(),
                  //     power_plant: params.power_plant,
                  //     billing: data
                  //     // billings: billings.docs
                  // }
                  // Billings.splice(newIndex, 0, new_doc)
                  // if(new_doc.competence === formatcompetence) commit('setTotalBilling', new_doc)
                } else if (type === "modified") {
                  // console.log('setLoadingBillings_modified4.idx' + idx + ':,' + state.loadingBillings)
                  // remove the old one first
                  await Billings.splice(oldIndex, 1);
                  // if we want to handle references we would have to unsubscribe
                  // from old references' listeners and subscribe to the new ones
                  // console.log('modifield uc: ', doc.id)
                  // console.log('formatcompetence: ', formatcompetence)
                  const billings = await firestore
                    .collection("billings")
                    .where("consumer_unit", "==", doc.id)
                    .where("competence", "==", formatcompetence)
                    .limit(1)
                    .get();

                  if (billings.size > 0) {
                    const docBill = billings.docs[0];
                    const data = {
                      id: doc.id,
                      ...doc.data(),
                      billing: {
                        id: docBill.id,
                        ...docBill.data(),
                      },
                    };
                    await Billings.splice(newIndex, 0, data);
                    // console.log("Billings3: ")
                    // // items_Complete.push(data)
                    // console.log("items_Complete3: ", data)
                    // // const billing_changes = billings.docChanges()
                    // console.log('billing_changes: ', billing_changes)
                    // for (var y = 0; y < (billings.size - 1); y++) {
                    // // for(const bill of billing_changes.entries()) {
                    //     // const { newBillIndex, oldBillIndex, docBill, typeBill } = bill
                    //     const docBill = billings.docs[y]
                    //     console.log('bill type: ', docBill)
                    //     const data = {
                    //         sum,
                    //         id: doc.id,
                    //         ...doc.data(),
                    //         billing: {
                    //             id: docBill.id,
                    //             ...docBill.data()
                    //         }
                    //     }
                    //     await Billings.splice(newIndex, 0, data)
                    //     sum = sum++
                    //     // await items.push(data)
                    //     // await items_complete.push(data)
                    // }
                  } else {
                    const data = {
                      id: doc.id,
                      ...doc.data(),
                      billing: null,
                    };
                    await Billings.splice(newIndex, 0, data);
                    // console.log("Billings: ")
                    // // items_Complete.push(data)
                    // console.log("items_Complete4: ", data)
                    // await items.push(data)
                    // await items_complete.push(data)
                  }
                } else if (type === "removed") {
                  // if(sale.data().payment_competence) salesPaid = salesPaid + 1
                  await Billings.splice(oldIndex, 1);
                  // console.log("Billings remove: ")
                  await items_Complete.splice(oldIndex, 1);
                  // console.log("items_Complete: remove")
                  // if we want to handle references we need to unsubscribe
                  // from old references
                } else {
                  commit("setLoadingBillings", false);
                }
                // console.log('idx: ', idx)
                // console.log('changes: ', (changes.length - 1))
                if (idx >= changes.length - 1) {
                  // console.log('doc:', doc.id)
                  commit("setLastItem", doc.id);
                  // console.log("last3: ", state.lastItem)

                  commit("setLoadingBillings", false);
                  // console.log('setLoadingBillings5: ', state.loadingBillings)

                  // console.log('Fim: ',Billings)
                  commit("setItems", Billings);
                  commit(
                    "setItemsComplete",
                    state.itemsComplete.concat(Billings),
                  );
                  // commit('setLastItem', Billings[Billings.length - 1])
                  // commit('setLoadingTotalBillings', false)
                }
              }

              // console.log('setLoadingBillings: ', await false)

              return await Billings;
            },
          );
        }
      }
    } catch (err) {
      commit("setItems", []);
      // commit('setLoadingTotalBillings', false)
      console.error(err);
    }
  },

  async getBillingsOnSubcollection(context, batch_id) {
    const collectionRef = firestore
      .collection("bank_batchs")
      .doc(batch_id)
      .collection("batch_billets");
    return collectionRef.get().then((item) => {
      let data = {};
      for (let i = 0; i < item.docs.length; i++) {
        const billing_id = item.docs[i].data().billing_id;
        const name = `billing_id_${i}`;
        data[name] = billing_id;
      }
      return data;
    });
  },

  async getBankBatchs({ state, commit }) {
    commit("setLoadingBankBatchs", true);
    commit("setBankBatchs", []);
    try {
      let bankBatchsRef = firestore.collection("bank_batchs");
      return bankBatchsRef.get().then(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          let count = 0;
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                let data = {
                  id: doc.id,
                  ...doc.data(),
                };

                if (!data.type || data?.type !== "usinas") {
                  commit("pushBankBatchs", data);
                }

                count++;
                if (count === res.size) {
                  commit("setLoadingBankBatchs", false);
                }

                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                // eslint-disable-next-line no-shadow
                const i = state.bankBatchs.findIndex((i) => i.id === doc.id);
                commit("splitBankBatchs", { index: i, data: data });
                break;
              }
              case "removed": {
                state.bankBatchs.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          });
          return true;
        } else {
          commit("setLoadingBankBatchs", false);
          await commit("setBankBatchs", []);
        }
        await commit("setLoadingBankBatchs", false);
      });
    } catch (err) {
      await commit("setLoadingBankBatchs", false);
      await commit("setBankBatchs`", []);
      console.error(err);
    }
  },

  async getBankBatchsUsinas({ state, commit }) {
    commit("setLoadingBankBatchsUsinas", true);
    commit("setBankBatchsUsinas", []);
    try {
      let bankBatchsUsinasRef = firestore.collection("bank_batchs");
      bankBatchsUsinasRef = bankBatchsUsinasRef.where("type", "==", "usinas");
      return bankBatchsUsinasRef.get().then(async (res) => {
        if (res.size > 0) {
          const changes = res.docChanges();
          let count = 0;
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                let data = {
                  id: doc.id,
                  ...doc.data(),
                };
                data.scheduled_date = data.scheduled_date
                  ? moment(data.scheduled_date, "DD/MM/YYYY").toDate()
                  : data.scheduled_date;
                commit("pushBankBatchsUsinas", data);
                count++;
                if (count === res.size) {
                  commit("setLoadingBankBatchsUsinas", false);
                }
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                // eslint-disable-next-line no-shadow
                const i = state.bankBatchsUsinas.findIndex(
                  (i) => i.id === doc.id,
                );
                commit("splitBankBatchsUsinas", { index: i, data: data });
                break;
              }
              case "removed": {
                state.bankBatchsUsinas.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          });
          return true;
        } else {
          commit("setLoadingBankBatchsUsinas", false);
          commit("setBankBatchsUsinas", []);
        }
        commit("setLoadingBankBatchsUsinas", false);
      });
    } catch (err) {
      commit("setLoadingBankBatchsUsinas", false);
      commit("setBankBatchsUsinas`", []);
      console.error(err);
    }
  },

  async getDueDate(context, billing_id) {
    const doc = await getBilling(billing_id).get();
    if (doc.exists) {
      return doc.data().due_date_utility;
    } else {
      return null;
    }
  },

  async getUtilityPaymentStatus(context, billing_id) {
    const doc = await getBilling(billing_id).get();
    if (doc.exists) {
      return doc.data().utility_payment_status;
    } else {
      return null;
    }
  },

  async getBankBatchType(context, batch_id) {
    const doc = await firestore.collection("bank_batchs").doc(batch_id).get();
    if (doc.exists) {
      return doc.data().type;
    } else {
      return null;
    }
  },

  async getBankBatchByScheduledDate(context, scheduled_date) {
    const querySnapshot = await firestore
      .collection("bank_batchs")
      .where("scheduled_date", "==", scheduled_date)
      .get();
    if (!querySnapshot.empty) {
      const doc = querySnapshot.docs[0];
      return doc.id;
    } else {
      return null;
    }
  },

  async updateEmail(context, { user_email, batch_id, billet_id }) {
    const docRef = firestore
      .collection("bank_batchs")
      .doc(batch_id)
      .collection("batch_billets")
      .doc(billet_id);
    try {
      const doc = await docRef.get();
      if (doc.exists) {
        await docRef.update({
          marked_as_manually_paid_by: user_email,
          marked_at: new Date(),
          updated_at: new Date(),
        });
      } else {
        throw new Error("Documento não encontrado");
      }
    } catch (error) {
      throw new Error(error);
    }
  },

  async markUserEmailBatch(context, { user_email, batch_id }) {
    const docRef = firestore.collection("bank_batchs").doc(batch_id);
    try {
      const doc = await docRef.get();
      if (doc.exists) {
        await docRef.update({
          generated_by: user_email,
          generated_at: new Date(),
          updated_at: new Date(),
        });
      } else {
        throw new Error("Documento não encontrado");
      }
    } catch (error) {
      throw new Error(error);
    }
  },

  async getSheetData(context, batch_id) {
    const data = [];
    const bb_data = async () => {
      const bbRef = await firestore
        .collection("bank_batchs")
        .doc(batch_id)
        .collection("batch_billets")
        .get();
      const promises = bbRef.docs.map(async (billet) => {
        const competence = billet.data().competence;
        const total_invoice = billet.data().total_invoice;
        const uc = String(billet.data().xml_id).split("_")[0];
        const status = String(billet.data().status);
        const paid_at = billet.data().paid_at
          ? formatDate(billet.data().paid_at)
          : "-";
        const power_plant = await firestore
          .collection("power_plants")
          .where("installation_number", "==", uc)
          .get();
        const ufv_name = power_plant.docs[0].id;
        const xml_id = billet.data().xml_id;
        data.push({
          competence: competence,
          total_invoice: total_invoice,
          uc: uc,
          status: status,
          paid_at: paid_at,
          ufv_name: ufv_name,
          xml_id: xml_id,
        });
      });
      await Promise.all(promises);
    };

    const ix_data = async () => {
      await Promise.all(
        data.map(async (item) => {
          const bill_id = getBillId(item.xml_id);
          const bills = await firestore.collection("bills").doc(bill_id).get();
          const ix_id = item.xml_id;
          const ix = await firestore
            .collection("invoices_xml")
            .doc(ix_id)
            .get();
          if (!bills.exists) {
            const docData = ix.data();
            const emissao = docData.emissao
              ? convertDate(docData.emissao)
              : "-";
            const nota_fiscal = docData.nota_fiscal ? docData.nota_fiscal : "-";
            item.emissao = emissao;
            item.nota_fiscal = nota_fiscal;
            return;
          }
          const docData = bills.data();
          const emissao = docData.emissao ? convertDate(docData.emissao) : "-";
          const nota_fiscal = docData.nota_fiscal ? docData.nota_fiscal : "-";
          item.emissao = emissao;
          item.nota_fiscal = nota_fiscal;
        }),
      );
    };
    await bb_data();
    await ix_data();

    return data;
  },

  async getBilletsBankBatch({ state, commit, dispatch }, batch_id) {
    commit("setBilletsBankBatch", []);
    try {
      commit("setLoadingBankBatchs", true);
      const billetsBankBatchRef = firestore
        .collection("bank_batchs")
        .doc(batch_id)
        .collection("batch_billets");
      return billetsBankBatchRef.onSnapshot(async (res) => {
        console.log("size:", res.size);
        if (res.size > 0) {
          const changes = res.docChanges();
          changes.forEach(async (change) => {
            const { doc } = change;
            switch (change.type) {
              case "added": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const due_date_utility = await dispatch(
                  "getDueDate",
                  doc.data().billing_id,
                );
                const utility_payment_status = await dispatch(
                  "getUtilityPaymentStatus",
                  doc.data().billing_id,
                );
                data.utility_payment_status = utility_payment_status;
                data.due_date_utility = due_date_utility;
                commit("pushBilletsBankBatch", data);
                break;
              }
              case "modified": {
                const data = {
                  id: doc.id,
                  ...doc.data(),
                };
                const i = state.billetsBankBatch.findIndex(
                  (i) => i.id === doc.id,
                );
                commit("splitBilletsBankBatch", { index: i, data: data });
                break;
              }
              case "removed": {
                state.billetsBankBatch.filter((i) => i.id !== doc.id);
                break;
              }
              default:
                break;
            }
          });
          await commit("setLoadingBankBatchs", false);
          return true;
        } else {
          await commit("setBilletsBankBatch", []);
        }
        await commit("setLoadingBankBatchs", false);
      });
    } catch (err) {
      await commit("setLoadingBankBatchs", false);
      await commit("setBilletsBankBatch", []);
      console.error(err);
    }
  },
};

function getCompetences(competence_year, competence_month) {
  let competences = [];
  let current_month = new Date().getMonth() + 1;
  // let competence_month = competence.substring(0,2)
  // let competence_year = competence.substring(2,6)
  let diff_month = Number(current_month) - Number(competence_month);
  if (diff_month < 0) diff_month = 2;
  if (diff_month > 2) diff_month = 2;
  // console.log('diff_month: ', diff_month)
  var value = competence_year + "-" + competence_month + "-" + "01";
  // console.log('value: ', value)
  var datetime1 = moment(value);
  // console.log('datetime1: ', datetime1)
  let ano = Number(datetime1.format("YYYY"));
  // console.log('ano: ', ano)
  datetime1.subtract(4 - diff_month, "month");
  // console.log('datetime1b: ', datetime1)
  let mes = Number(datetime1.month());
  ano = Number(datetime1.format("YYYY"));
  ano = Number(datetime1.year());
  // console.log('ano2: ', ano)
  for (var i = 0; i <= 4; i++) {
    // console.log('mes: ', mes)
    if (mes > 12) {
      // console.log('mes2: ', mes)
      mes = 1;
      ano = ano + 1;
    }
    // else {
    //     mes = mes + 1
    // }
    let mes_format = mes > 9 ? mes : "0" + mes;
    // console.log('mes_format: ', mes_format)

    let comp = ano + "-" + mes_format;
    // console.log('comp: ', comp)
    competences.push(comp);
    mes = mes + 1;
  }
  let comp = competence_year + "-" + competence_month;
  if (!competences.includes(comp)) {
    competences.push(comp);
  }
  return competences;
}

function formatDate(value) {
  if (!value) return "";
  return moment(value.toDate()).format("DD/MM/YYYY");
}

function convertDate(value) {
  if (!value) return "";
  const data = moment(value, "YYYY-MM-DD");
  return data.format("DD/MM/YYYY");
}

function getBillId(data) {
  const obterNomeMes = (mes) => {
    const meses = [
      "JAN",
      "FEV",
      "MAR",
      "ABR",
      "MAI",
      "JUN",
      "JUL",
      "AGO",
      "SET",
      "OUT",
      "NOV",
      "DEZ",
    ];
    const indice = parseInt(mes) - 1;
    if (indice < 0 || indice >= meses.length) {
      throw new Error("Mês inválido.");
    }
    return meses[indice];
  };

  const partes = data.split("_");
  if (partes.length !== 2) {
    throw new Error("Formato de entrada inválido.");
  }
  const [numero, dataStr] = partes;
  const [ano, mes] = dataStr.split("-");
  const nomeMes = obterNomeMes(mes);
  return `${numero}_${nomeMes}-${ano}`;
}
